<template>
  <DashboardHeader @queryWindow="handleQueryWindow" />
  <a-layout class="pr-admin-window">
    <div class="section-first">
      <div class="section-row">
        <span class="title">Filters</span>
        <a-form class="form" layout="inline" :model="formData">
          <a-form-item class="form-item">
            <a-select
              class="form-item-select"
              :open="categoryOpen"
              @focus="handleCategoryFocus"
              @blur="handleCategoryBlur"
              ref="selectCategory"
              :dropdownMatchSelectWidth="false"
            >
              <template #placeholder>
                <div class="placeholder">
                  <img src="@/assets/dashboard/category-prefix.svg" />

                  {{
                    selectedCategoryQueries.length === 0
                    ? defaultCategoryPlaceholder
                    : selectedCategoryQueriesPlaceholder
                  }}
                </div>
              </template>
              <template #dropdownRender>
                <Tree
                  title="Publicis China"
                  :list="categories"
                  :selected="selectedCategoryQueries"
                  @query="handleQuery"
                  @cancel="handleCategoryCancel"
                  type="category"
                />
              </template>
            </a-select>
          </a-form-item>
          <a-form-item class="form-item">
            <a-select
              class="form-item-select"
              :open="locationOpen"
              @focus="handleLocationFocus"
              @blur="locationOpen = false"
              ref="selectLocation"
              :dropdownMatchSelectWidth="false"
            >
              <template #placeholder>
                <div class="placeholder">
                  <img src="@/assets/dashboard/location-prefix.svg" />
                  {{
                    selectedLocationQueries.length === 0
                    ? defaultLocationPlaceholder
                    : selectedLocationQueriesPlaceholder
                  }}
                </div>
              </template>
              <template #dropdownRender>
                <DashboardDropdownRender
                  title="All locations"
                  :list="locations"
                  :selected="selectedLocationQueries"
                  @query="handleQuery"
                  @cancel="handleLocationCancel"
                  type="location"
                />
              </template>
            </a-select>
          </a-form-item>
          <span class="title">Option</span>
          <a-form-item class="form-item">
            <a-select
              class="form-item-select"
              :open="levelOpen"
              @focus="handleLevelFocus"
              @blur="levelOpen = false"
              ref="selectLevel"
              :dropdownMatchSelectWidth="false"
            >
              <template #placeholder>
                <div class="placeholder">
                  <img src="@/assets/dashboard/level-prefix.svg" />

                  {{
                    isDefaultLevel
                    ? defaultLevelPlaceholder
                    : selectedLevelQueriesPlaceholder
                  }}
                </div>
              </template>
              <template #dropdownRender>
                <LevelTree
                  v-if="loading"
                  title="All Roles & Levels"
                  :list="levels"
                  :tRoles="tRoles"
                  :tValues="tValues"
                  :selected="selectLevel"
                  @query="handleQuery"
                  @cancel="handleLevelCancel"
                  type="level"
                />
              </template>
            </a-select>
          </a-form-item>
        </a-form>
      </div>
      <div class="section-row selected">
        <div class="content">
          <div class="reset" @click="handleReset">
            <img src="@/assets/dashboard/reset.png" />
            <div>Reset</div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-second">
      <div class="section-second-left">
        <div class="section-row">
          <div class="section-column">
            <div class="section-column-header">
              <span class="title">Eligible ROAR Talent</span>
              <a-tooltip placement="bottom" title="Eligible ROAR Talent number">
                <img src="@/assets/dashboard/exclamation.svg" />
              </a-tooltip>
            </div>
            <div class="members">
              {{ members }}
            </div>
          </div>
          <div class="section-column">
            <div class="section-column-header">
              <span class="title">Register</span>
              <a-tooltip placement="bottom">
                <template #title>
                  Register rate1 = Registered Talent / Eligible ROAR Talent
                  <br />
                  Register rate1 = Registered Review Manager / Eligible review
                  manager
                </template>
                <img src="@/assets/dashboard/exclamation.svg" />
              </a-tooltip>
            </div>
            <div class="registers">
              <div class="register">
                <span class="ratio">
                  {{
                    registers.talent?.registered
                    ? Math.round(
                      (registers.talent?.registered /
                        registers.talent?.total) *
                      100
                    ) + '%'
                    : '0%'
                  }}
                </span>
                <span class="tag">Talent</span>
                <span class="amount">
                  {{ registers.talent?.registered }} /
                  {{ registers.talent?.total }}
                </span>
              </div>
              <div class="register">
                <span class="ratio">
                  {{
                    registers.manager?.registered
                    ? Math.round(
                      (registers.manager?.registered /
                        registers.manager?.total) *
                      100
                    ) + '%'
                    : '0%'
                  }}
                </span>
                <span class="tag">Review Manager</span>
                <span class="amount">
                  {{ registers.manager?.registered }} /
                  {{ registers.manager?.total }}
                </span>
              </div>
            </div>
          </div>
          <div class="section-column">
            <div class="section-column-header">
              <span class="title">Apply</span>
              <a-tooltip
                placement="bottom"
                title="Apply rate = Apply number / Eligible ROAR Talent number"
              >
                <img src="@/assets/dashboard/exclamation.svg" />
              </a-tooltip>
            </div>
            <div class="applications">
              <div class="ratio">
                {{
                  applications.applied
                  ? Math.round(
                    (applications.applied / applications.total) * 100
                  ) + '%'
                  : '0%'
                }}
              </div>
              <div class="amount">
                {{ applications.applied }} / {{ applications.total }}
              </div>
              <div class="line">
                <div
                  class="line-applied"
                  :style="{
                    width: applications.applied
                      ? `${(applications.applied / applications.total) * 100}%`
                      : 0,
                  }"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div class="section-row">
          <div class="section-row-sub section-row-nogap">
            <div class="section-column">
              <div class="section-column-header">Approve for Panel</div>
              <div class="section-column-content">
                <div class="section-column-content-left">
                  <div class="ratio">
                    {{
                      status.total !== 0
                      ? `${Math.round(
                        (status.approved / status.total) * 100
                      )}%`
                      : ''
                    }}
                  </div>
                  <div class="amount">
                    {{ status.approved }} / {{ status.total }}
                  </div>
                </div>
                <div style="width: 40px; height: 40px">
                  <DoughnutChart
                    :value="[status.approved, status.total - status.approved]"
                  />
                </div>
              </div>
            </div>
            <div class="section-column">
              <div class="section-column-header">Pending</div>
              <div class="section-column-content">
                <div class="section-column-content-left">
                  <div class="ratio">
                    {{
                      status.total !== 0
                      ? `${Math.round(
                        (status.pending / status.total) * 100
                      )}%`
                      : 0
                    }}
                  </div>
                  <div class="amount">
                    {{ status.pending }} / {{ status.total }}
                  </div>
                </div>
                <div style="width: 40px; height: 40px">
                  <DoughnutChart
                    :value="[status.pending, status.total - status.pending]"
                  />
                </div>
              </div>
            </div>
            <a-tooltip placement="bottom">
              <template #title>
                Approve rate = Approve number / Apply number
                <br />
                Pending rate = Pending number /Apply number
              </template>
              <img src="@/assets/dashboard/exclamation.svg" />
            </a-tooltip>
          </div>
          <div class="section-row-sub section-row-nogap">
            <div class="section-column">
              <div class="section-column-header">Reopen manager</div>
              <div class="section-column-content">
                <div class="section-column-content-left">
                  <div class="ratio">
                    {{
                      status.total !== 0
                      ? `${Math.round(
                        (status.reopen_manager / status.total) * 100
                      )}%`
                      : 0
                    }}
                  </div>
                  <div class="amount">
                    {{ status.reopen_manager }} / {{ status.total }}
                  </div>
                </div>
                <div style="width: 40px; height: 40px">
                  <DoughnutChart
                    :value="[
                      status.reopen_manager,
                      status.total - status.reopen_manager,
                    ]"
                  />
                </div>
              </div>
            </div>
            <div class="section-column">
              <div class="section-column-header">Reopen both</div>
              <div class="section-column-content-left">
                <div class="ratio">
                  {{ status.reopen_both }}
                </div>
              </div>
            </div>
            <a-tooltip placement="bottom">
              <template #title>
                Reopen manager rate = Reopen manager number / Apply number
              </template>
              <img src="@/assets/dashboard/exclamation.svg" />
            </a-tooltip>
          </div>
        </div>
        <div class="section-row section-row-nogap">
          <div class="section-column">
            <div class="section-column-header">Success</div>
            <div class="success">
              {{ success.success }}
            </div>
          </div>
          <div class="section-column">
            <div class="section-column-header">Success / Application</div>
            <div class="section-column-content">
              <div class="section-column-content-left">
                <div class="ratio">
                  {{
                    success.success
                    ? `${Math.round(
                      (success.success / success.total) * 100
                    )}%`
                    : 0
                  }}
                </div>
                <div class="amount">
                  {{ success.success }} / {{ success.total }}
                </div>
              </div>
              <div style="width: 40px; height: 40px">
                <DoughnutChart
                  :value="[success.success, success.total - success.success]"
                />
              </div>
            </div>
          </div>
          <div class="section-column">
            <div class="section-column-header">Success / Approval</div>
            <div class="section-column-content">
              <div class="section-column-content-left">
                <div class="ratio">
                  {{
                    success.success
                    ? `${Math.round(
                      (success.success / success.approval) * 100
                    )}%`
                    : 0
                  }}
                </div>
                <div class="amount">
                  {{ success.success }} / {{ success.approval }}
                </div>
              </div>
              <div style="width: 40px; height: 40px">
                <DoughnutChart
                  :value="[success.success, success.approval - success.success]"
                />
              </div>
            </div>
          </div>
          <a-tooltip placement="bottom">
            <template #title>
              Success number = Promotion+Salary adjustment+Transfer
              <br />
              Success rate 1 = Success / Approval
              <br />
              Success rate 2 = Success / Application
            </template>
            <img src="@/assets/dashboard/exclamation.svg" />
          </a-tooltip>
        </div>
      </div>
      <div class="section-second-right">
        <div class="section-row-header">
          <span class="section-title">Not Match</span>
          <a-tooltip placement="bottom">
            <template #title>
              Rate 1 = Brand in system and talent selected current brand not
              match / Apply
              <br />
              Rate 2 = Current brand & target brand not match / Apply
              <br />
              Rate 3 = Current role & target role not
            </template>
            <img src="@/assets/dashboard/exclamation.svg" />
          </a-tooltip>
        </div>
        <div
          class="section-row-content"
          v-for="(notMatchDatum, index) in notMatchData.list"
          :key="index"
        >
          <div class="section-label">{{ notMatchDatum.label }}</div>
          <div class="section-number">
            <div class="section-ratio">
              {{
                notMatchData.total !== 0
                ? Math.round((notMatchDatum.num / notMatchData.total) * 100)
                : '0'
              }}%
            </div>
            <div class="section-amount">
              {{ notMatchDatum.num }}/{{ notMatchData.total }}
            </div>
          </div>
          <img
            class="download-icon"
            src="@/assets/dashboard/download.svg"
            @click="loadNotMatch(true, index + 1)"
          />
        </div>
      </div>
    </div>
    <div class="section-third">
      <div class="apply-header">
        Apply number by location & by agency
        <img
          class="download-icon"
          src="@/assets/dashboard/download.svg"
          @click="loadApplicationsByLocationAndAgency(true)"
        />
      </div>
      <div class="apply-category">
        <div v-for="c in applyCategories" :key="c.name">
          <div class="apply-category-num">{{ c.num }}</div>
          <div>
            <div
              class="apply-category-color"
              :style="{ backgroundColor: c.color }"
            ></div>
            <div class="apply-category-name">{{ c.name }}</div>
          </div>
        </div>
      </div>
      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        class="apply-table"
      >
        <template #headerCell="{ title }">
          <div style="white-space: nowrap">{{ title }}</div>
        </template>
        <template #bodyCell="{ text }">
          <div style="white-space: nowrap">
            {{ text }}
          </div>
        </template>
      </a-table>
    </div>
    <div class="section-forth">
      <div class="section-column">
        <div class="panel-result-header">
          <div class="panel-result-header-left">
            <span class="title">Panel Result</span>
            <a-tooltip placement="bottom">
              <template #title>
                 • Promotion / Approve number
                <br />
                • Salary Adjustment / Approve number
                <br />
                • Transfer / Approve number
                <br />
                • Try again next time / Approve number
                <br />
                • No show / Approve number
                <br />
                • Resigned / Approve number
                <br />
              </template>
              <img src="@/assets/dashboard/exclamation.svg" />
            </a-tooltip>
          </div>
          <div class="panel-result-header-right">
            <img
              class="download-icon"
              src="@/assets/dashboard/download.svg"
              @click="loadPanelResult(true)"
            />
          </div>
        </div>
        <div class="panel-result-content">
          <div
            class="panel-result-content-left"
            style="width: 176px; height: 176px"
          >
            <Doughnut
              :width="176"
              :height="176"
              :chart-data="chartData"
              :chartOptions="chartOptions"
            />
          </div>
          <div class="panel-result-content-right">
            <PanelResultData
              v-for="datum in panelResultData"
              :key="datum"
              :backgroundColor="datum.backgroundColor"
              :label="datum.label"
              :value="datum.value"
              :total="panelResultTotal"
            />
          </div>
        </div>
      </div>
      <div class="section-column">
        <div class="time-of-success-header">
          Times of success
          <img
            class="download-icon"
            src="@/assets/dashboard/download.svg"
            @click="downloadTimeOfSuccess()"
          />
        </div>
        <TimesOfSuccessTable
          :dataSource="tDataSource"
          @change="loadTimeOfSuccess"
          :total="tTotal"
        />
      </div>
    </div>
    <div class="section-fifth">
      <div>
        <div class="panel-result-header">
          Panel Result by location
          <img
            class="download-icon"
            src="@/assets/dashboard/download.svg"
            @click="loadPanelResultByLocation(true)"
          />
        </div>
        <HorizontalStackedBarChart
          :chartData="panelResultByLocationData"
          legendId="location"
          :canScroll="false"
        />
      </div>
      <div>
        <div class="panel-result-header">
          Panel Result by agency
          <img
            class="download-icon"
            src="@/assets/dashboard/download.svg"
            @click="loadPanelResultByAgency(true)"
          />
        </div>
        <HorizontalStackedBarChart
          :chartData="panelResultByAgencyData"
          legendId="agency"
        />
      </div>
    </div>
  </a-layout>
</template>
<script>
import { mapGetters } from 'vuex'
import DashboardHeader from './components/DashboardHeader.vue'
import PanelResultData from './components/PanelResultData.vue'
import DoughnutChart from './components/DoughnutChart.vue'
import HorizontalStackedBarChart from './components/HorizontalStackedBarChart.vue'
import TimesOfSuccessTable from './components/TimesOfSuccessTable.vue'
import DashboardDropdownRender from './components/DashboardDropdownRender.vue'
import DashboardTreeDropdownRender from './components/DashboardTreeDropdownRender.vue'
import DashboardLevelDropdownRender from './components/DashboardLevelDropdownRender.vue'
import { Doughnut } from 'vue-chartjs'
import {
  configBarData,
  configTableData,
  configHeaderColor,
} from '@/utils/chart'
import {
  getCategories,
  getLocations,
  getRoles,
  getBrandRoles,
  getLevels,
  getBrandRoleLevels,
  getEmployees,
  getRegisters,
  getApplications,
  getStatus,
  getSuccess,
  getGuideMapping,
  getNotMatch,
  getApplicationsByLocationAndAgency,
  getPanelResult,
  getTimeOfSuccess,
  getPanelResultByLocation,
  getPanelResultByAgency,
} from '@/api/dashboard'
import { downLoadFileFromRequest } from '@/utils/index'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  Plugin,
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

const panelResultColors = [
  '#F9C180',
  '#F4E55B',
  '#36CFB3',
  '#5DA2F3',
  '#9BD4E0',
  '#B8D4A0',
]

export default {
  components: {
    DashboardHeader,
    PanelResultData,
    Doughnut,
    DoughnutChart,
    HorizontalStackedBarChart,
    TimesOfSuccessTable,
    DashboardDropdownRender,
    Tree: DashboardTreeDropdownRender,
    LevelTree: DashboardLevelDropdownRender,
  },
  data() {
    return {
      loading: false,
      selectLevel: {},
      selectedLevelBak: {},
      query: {},
      selectedQueries: [],
      selectedQueriesBak: [],
      chartData: {},
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            top: -10,
          },
        },
        borderWidth: 1,
        plugins: {
          legend: {
            display: false,
          },
        },
      },
      notMatchData: [],
      formData: {},
      categories: [],
      locations: [],
      roles: [],
      levels: [],
      members: 0,
      registers: {},
      applications: {},
      status: {},
      success: {},
      panelResultData: [],
      panelResultTotal: 0,
      columns: [],
      applyCategories: [],
      dataSource: [],
      panelResultByLocationData: {},
      panelResultByAgencyData: {},
      tDataSource: [],
      tTotal: 0,
      categoryOpen: false,
      locationOpen: false,
      roleOpen: false,
      levelOpen: false,
      pagination: {},
      defaultCategoryPlaceholder: 'Publicis China',
      defaultLocationPlaceholder: 'All Locations',
      defaultRolePlaceholder: 'All Roles',
      defaultLevelPlaceholder: 'All Roles & Levels',
      hideCnt: 0,
      hideCategoryCnt: 0,
      hideLocationCnt: 0,
      hideRoleCnt: 0,
      hideLevelCnt: 0,
      roleMap: {},
    }
  },
  computed: {
    ...mapGetters({
      Authorization: 'user/accessToken',
      ability: 'acl/ability',
    }),
    selectedQueriesHide() {
      if (this.selectedQueries.length === this.hideCnt) return []
      const s1 =
        this.selectedQueries.filter((e) => e.type === 'category').length ===
          this.hideCategoryCnt
          ? []
          : this.selectedQueries.filter((e) => e.type === 'category')
      const s2 =
        this.selectedQueries.filter((e) => e.type === 'location').length ===
          this.hideLocationCnt
          ? []
          : this.selectedQueries.filter((e) => e.type === 'location')
      const s3 =
        this.selectedQueries.filter((e) => e.type === 'role').length ===
          this.hideRoleCnt
          ? []
          : this.selectedQueries.filter((e) => e.type === 'role')
      const s4 =
        this.selectedQueries.filter((e) => e.type === 'level').length ===
          this.hideLevelCnt
          ? []
          : this.selectedQueries.filter((e) => e.type === 'level')

      return [...s1, ...s2, ...s3, ...s4]
    },
    selectedCategoryQueries: function () {
      return this.selectedQueries
        .filter((el) => el.type === 'category')
        .map((el) => el.label)
    },
    selectedCategoryQueriesPlaceholder() {
      const queryPlaceholder = this.selectedCategoryQueries.join('、')
      if (this.selectedCategoryQueries.length === this.categoryCount)
        return this.defaultCategoryPlaceholder
      if (queryPlaceholder.length > 36) {
        return queryPlaceholder.substring(0, 36) + '...'
      } else {
        return queryPlaceholder
      }
    },
    selectedLocationQueries: function () {
      return this.selectedQueries
        .filter((el) => el.type === 'location')
        .map((el) => el.label)
    },
    selectedLocationQueriesPlaceholder() {
      const queryPlaceholder = this.selectedLocationQueries.join('、')
      if (this.selectedLocationQueries.length === this.locationCount)
        return this.defaultLocationPlaceholder
      if (queryPlaceholder.length > 36) {
        return queryPlaceholder.substring(0, 36) + '...'
      } else {
        return queryPlaceholder
      }
    },
    selectedRoleQueries: function () {
      return this.selectedQueries
        .filter((el) => el.type === 'role')
        .map((el) => el.label)
    },
    selectedRoleQueriesPlaceholder() {
      const queryPlaceholder = this.selectedRoleQueries.join('、')
      if (this.selectedRoleQueries.length === this.roleCount)
        return this.defaultRolePlaceholder

      if (queryPlaceholder.length > 36) {
        return queryPlaceholder.substring(0, 36) + '...'
      } else {
        return queryPlaceholder
      }
    },
    selectedLevelQueries: function () {
      return this.selectedQueries
        .filter((el) => el.type === 'level')
        .map((el) => el.label)
    },
    selectedLevelQueriesPlaceholder() {
      const queryPlaceholder = Object.values(this.selectLevel)
        .reduce((prev, next) => prev.concat(next), [])
        .join('、')
      if (queryPlaceholder.length > 36) {
        return queryPlaceholder.substring(0, 36) + '...'
      } else {
        return queryPlaceholder
      }
    },
    categoryCount() {
      if (this.categories.length === 0) return 0
      const cnt = this.categories
        .map((e) => e.children.length)
        .reduce((prev, next) => prev + next, 0)
      return cnt
    },
    locationCount() {
      if (this.locations.length === 0) return
      return this.locations.length
    },
    roleCount() {
      if (this.roles.length === 0) return
      return this.roles.length
    },
    levelCount() {
      if (this.levels.length === 0) return
      return this.levels.length
    },
    isDefaultLevel() {
      const l1 = Object.values(this.selectLevel).reduce(
        (prev, next) => prev.concat(next),
        []
      ).length
      const l2 = Object.values(this.selectedLevelBak).reduce(
        (prev, next) => prev.concat(next),
        []
      ).length
      return l1 === l2
    },
  },

  methods: {
    async handleQueryWindow(cycle_id) {
      this.query = { ...this.query, cycle_id }

      await this.loadCategories()

      let payload = { brands: this.query.category, cycle_id }

      await this.loadBrandRoleLevels(payload)

      await this.loadData()
    },

    async handleQuery(query, type) {
      this.$refs['selectCategory'].blur()
      this.$refs['selectLocation'].blur()
      this.$refs['selectLevel'].blur()

      switch (type) {
        case 'category': {
          this.query = { ...this.query, category: query }
          break
        }
        case 'location': {
          this.query = { ...this.query, location: query }
          break
        }
        case 'role': {
          this.query = { ...this.query, role: query }
          break
        }
        case 'level': {
          let queryNotEmpty = {}
          Object.keys(query)
            .filter((key) => query[key].length !== 0)
            .forEach((key) => {
              queryNotEmpty[key] = query[key]
            })

          this.query = { ...this.query, level: queryNotEmpty }
          this.selectLevel = { ...query }
          break
        }
      }

      let tmpSelectedQuery = []
      if (this.query.category) {
        tmpSelectedQuery = [
          ...tmpSelectedQuery,
          ...this.query.category.map((el) => ({
            label: el,
            type: 'category',
          })),
        ]
      }
      if (this.query.location) {
        tmpSelectedQuery = [
          ...tmpSelectedQuery,
          ...this.query.location.map((el) => ({
            label: el,
            type: 'location',
          })),
        ]
      }
      this.selectedQueries = tmpSelectedQuery

      if (type === 'category') {
        const { cycle_id } = this.query
        let payload = { brands: this.query.category }
        if (cycle_id) {
          payload = { ...payload, cycle_id }
        }

        await this.loadBrandRoleLevels(payload)
      }

      await this.loadData()
    },
    async loadSelect() {
      await this.loadCategories()
      await this.loadLocations()
      await this.loadBrandRoles()
      const categoryChildren = this.categories
        .map((e) => e.children)
        .reduce((prev, next) => prev.concat(next), [])

      await this.loadBrandRoleLevels({ brands: categoryChildren })
    },
    async loadData() {
      await this.loadGuideMapping()
      this.loadEmployees()
      this.loadRegisters()
      this.loadApplications()
      this.loadStatus()
      this.loadSuccess()
      this.loadNotMatch()
      this.loadApplicationsByLocationAndAgency()
      this.loadPanelResult()
      this.loadTimeOfSuccess()
      this.loadPanelResultByLocation()
      this.loadPanelResultByAgency()
    },
    async loadCategories() {
      try {
        const { cycle_id } = this.query
        let payload = {}
        if (cycle_id) {
          payload = { cycle_id }
        }
        const res = await getCategories(payload)
        this.categories = res.data
        const categoryChildren = this.categories
          .map((e) => e.children)
          .reduce((prev, next) => prev.concat(next), [])
        this.query = { ...this.query, category: categoryChildren }
        this.hideCnt += categoryChildren.length
        this.hideCategoryCnt = categoryChildren.length

        if (cycle_id) {
          this.selectedQueries = this.selectedQueries = [
            ...this.selectedQueries.filter((e) => e.type !== 'category'),
            ...this.categories
              .map((e) => e.children)
              .reduce((prev, next) => prev.concat(next), [])
              .map((label) => ({ label, type: 'category' })),
          ]
        } else {
          this.selectedQueries = [
            ...this.selectedQueries,
            ...this.categories
              .map((e) => e.children)
              .reduce((prev, next) => prev.concat(next), [])
              .map((label) => ({ label, type: 'category' })),
          ]
        }
      } catch (error) {
        console.log(error)
      }
    },
    async loadLocations() {
      try {
        const res = await getLocations()
        this.locations = res.data
        this.query = { ...this.query, location: this.locations }
        this.hideCnt += this.locations.length
        this.hideLocationCnt = this.locations.length
        this.selectedQueries = [
          ...this.selectedQueries,
          ...this.locations.map((label) => ({ label, type: 'location' })),
        ]
      } catch (error) {
        console.log(error)
      }
    },
    async loadRoles() {
      try {
        const res = await getRoles()
        this.roles = res.data
        this.query = { ...this.query, role: this.roles }
        this.hideCnt += this.roles.length
        this.hideRoleCnt = this.roles.length
        this.selectedQueries = [
          ...this.selectedQueries,
          ...this.roles.map((label) => ({ label, type: 'role' })),
        ]
      } catch (error) {
        console.log(error)
      }
    },
    async loadBrandRoles() {
      try {
        const res = await getBrandRoles()
        this.roles = Object.values(res.data).map((e) => {
          return e.reduce(
            (prev, next) => ({
              name: next.agency,
              children: prev.children
                ? prev.children.concat([next.role])
                : [].concat([next.role]),
            }),
            {}
          )
        })

        const roleChildren = this.roles
          .map((e) => e.children)
          .reduce((prev, next) => prev.concat(next), [])

        this.query = { ...this.query, role: this.roles }
        this.hideCnt += roleChildren.length
        this.hideRoleCnt = roleChildren.length
        this.selectedQueries = [
          ...this.selectedQueries,
          ...this.roles
            .map((e) => e.children)
            .reduce((prev, next) => prev.concat(next), [])
            .map((label) => ({ label, type: 'role' })),
        ]
      } catch (error) {
        console.log(error)
      }
    },

    async loadLevels() {
      try {
        const res = await getLevels()
        this.levels = res.data
        this.query = { ...this.query, level: this.levels }
        this.hideCnt += this.levels.length
        this.hideLevelCnt = this.levels.length
        this.selectedQueries = [
          ...this.selectedQueries,
          ...this.levels.map((label) => ({ label, type: 'level' })),
        ]
        this.selectedQueriesBak = [...this.selectedQueries]
      } catch (error) {
        console.log(error)
      }
    },

    async loadBrandRoleLevels(payload) {
      try {
        const res = await getBrandRoleLevels(payload || {})
        this.levels = res.data

        this.tRoles = Object.keys(this.levels)

        this.tValues = Object.keys(this.levels)
          .map((r, i) => {
            return { [r]: this.levels[r].map((e) => e.level) }
          })
          .reduce((prev, next) => {
            return { ...prev, ...next }
          }, {})

        this.selectLevel = this.tValues
        this.selectedLevelBak = this.tValues

        this.loading = true

        this.query = {
          ...this.query,
          level: this.tValues,
        }
        this.hideCnt += this.levels.length
        this.hideLevelCnt = this.levels.length
        this.selectedQueries = [...this.selectedQueries]
        this.selectedQueriesBak = [...this.selectedQueries]
      } catch (error) {
        console.log(error)
      }
    },

    async loadGuideMapping() {
      const { cycle_id } = this.query
      let payload = {}
      if (cycle_id) {
        payload = { ...payload, cycle_id }
      }
      try {
        const res = await getGuideMapping(payload)
        this.roleMap = res.data
      } catch (error) {
        console.log(error)
      }
    },

    async loadEmployees() {
      try {
        let payload =
          Object.keys(this.query).length > 0 ? { ...this.query } : {}

        if (payload.role && payload.role.length > 0) {
          payload.role =
            payload.role.length === this.roleCount
              ? []
              : payload.role
                .map((e) => this.roleMap[e])
                .filter((e) => {
                  return e != null
                })
        }

        const res = await getEmployees(payload)

        this.members = res.data.members
      } catch (error) {
        console.log(error)
      }
    },

    async loadRegisters() {
      try {
        let payload =
          Object.keys(this.query).length > 0 ? { ...this.query } : {}

        if (payload.role && payload.role.length > 0) {
          payload.role =
            payload.role.length === this.roleCount
              ? []
              : payload.role
                .map((e) => this.roleMap[e])
                .filter((e) => {
                  return e != null
                })
        }
        const res = await getRegisters(payload)
        this.registers = res.data
      } catch (error) {
        console.log(error)
      }
    },

    async loadApplications() {
      try {
        let payload =
          Object.keys(this.query).length > 0 ? { ...this.query } : {}

        if (payload.role && payload.role.length > 0) {
          payload.role =
            payload.role.length === this.roleCount
              ? []
              : payload.role
                .map((e) => this.roleMap[e])
                .filter((e) => {
                  return e != null
                })
        }
        const res = await getApplications(payload)
        this.applications = res.data
      } catch (error) {
        console.log(error)
      }
    },

    async loadStatus() {
      try {
        let payload =
          Object.keys(this.query).length > 0 ? { ...this.query } : {}

        if (payload.role && payload.role.length > 0) {
          payload.role =
            payload.role.length === this.roleCount
              ? []
              : payload.role
                .map((e) => this.roleMap[e])
                .filter((e) => {
                  return e != null
                })
        }
        const res = await getStatus(payload)
        this.status = res.data
      } catch (error) {
        console.log(error)
      }
    },

    async loadSuccess() {
      try {
        let payload =
          Object.keys(this.query).length > 0 ? { ...this.query } : {}

        if (payload.role && payload.role.length > 0) {
          payload.role =
            payload.role.length === this.roleCount
              ? []
              : payload.role
                .map((e) => this.roleMap[e])
                .filter((e) => {
                  return e != null
                })
        }
        const res = await getSuccess(payload)
        this.success = res.data
      } catch (error) {
        console.log(error)
      }
    },

    async loadNotMatch(download = false, type) {
      try {
        let payload =
          Object.keys(this.query).length > 0 ? { ...this.query } : {}

        if (payload.role && payload.role.length > 0) {
          payload.role =
            payload.role.length === this.roleCount
              ? []
              : payload.role
                .map((e) => this.roleMap[e])
                .filter((e) => {
                  return e != null
                })
        }
        let res
        if (download) {
          res = await getNotMatch(payload, true, this.Authorization, type)
          downLoadFileFromRequest(res)
        } else {
          res = await getNotMatch(payload)
          this.notMatchData = res.data
        }
      } catch (error) {
        console.log(error)
      }
    },

    async loadApplicationsByLocationAndAgency(download = false) {
      try {
        let payload =
          Object.keys(this.query).length > 0 ? { ...this.query } : {}

        if (payload.role && payload.role.length > 0) {
          payload.role =
            payload.role.length === this.roleCount
              ? []
              : payload.role
                .map((e) => this.roleMap[e])
                .filter((e) => {
                  return e != null
                })
        }
        let res
        if (download) {
          res = await getApplicationsByLocationAndAgency(
            payload,
            true,
            this.Authorization
          )
          downLoadFileFromRequest(res)
        } else {
          res = await getApplicationsByLocationAndAgency(payload)
          this.applyCategories = res.data.categories
          const { columns, dataSource } = configTableData(res.data.list)
          this.columns = columns
          this.dataSource = dataSource
          this.$nextTick(() => {
            configHeaderColor(res.data.mapping)
          })
        }
      } catch (error) {
        console.log(error)
      }
    },

    async loadPanelResult(download = false) {
      try {
        let payload =
          Object.keys(this.query).length > 0 ? { ...this.query } : {}

        if (payload.role && payload.role.length > 0) {
          payload.role =
            payload.role.length === this.roleCount
              ? []
              : payload.role
                .map((e) => this.roleMap[e])
                .filter((e) => {
                  return e != null
                })
        }
        let res
        if (download) {
          res = await getPanelResult(payload, true, this.Authorization)
          downLoadFileFromRequest(res)
        } else {
          res = await getPanelResult(payload)
          const {
            Promotion,
            ['Salary adjustment']: SalaryAdjument,
            Transfer,
            ['Try again next time']: TryAgainNextTime,
            ['No show']: NoShow,
            Resigned,
          } = res.data.results
          const labels = [
            'Promotion',
            'Salary adjustment',
            'Transfer',
            'Try again next time',
            'No show',
            'Resigned',
          ]
          const values = [
            Promotion,
            SalaryAdjument,
            Transfer,
            TryAgainNextTime,
            NoShow,
            Resigned,
          ]
          this.panelResultData = panelResultColors.map((el, index) => ({
            backgroundColor: el,
            label: labels[index],
            value: values[index],
          }))
          this.panelResultTotal = res.data.total
          const spaceLabels = labels.map((e) => ' ' + e)

          this.chartData = {
            labels: spaceLabels,
            datasets: [
              {
                backgroundColor: this.panelResultData.map(
                  (el) => el.backgroundColor
                ),
                data: [
                  Promotion,
                  SalaryAdjument,
                  Transfer,
                  TryAgainNextTime,
                  NoShow,
                  Resigned,
                ],
                cutout: '78.4%',
              },
            ],
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async loadTimeOfSuccess(data) {
      try {
        let params = { size: 5 }
        if (data && data.pagination) {
          this.pagination = data.pagination
          params = {
            ...data.pagination,
            size: data.pagination.pageSize,
            // pageNum: data.pagination.current,
            page: data.pagination.current,
          }
        }

        if (data && data.sortBy) {
          params = { ...params, sortBy: data.sortBy }
        }

        let payload =
          Object.keys(this.query).length > 0 ? { ...this.query } : {}

        if (payload.role && payload.role.length > 0) {
          payload.role =
            payload.role.length === this.roleCount
              ? []
              : payload.role
                .map((e) => this.roleMap[e])
                .filter((e) => {
                  return e != null
                })
        }

        payload = { ...payload, ...params }
        const res = await getTimeOfSuccess(payload)
        this.tDataSource = res.data
        this.tTotal = res.page.total
      } catch (error) {
        console.log(error)
      }
    },
    async downloadTimeOfSuccess() {
      try {
        let payload =
          Object.keys(this.query).length > 0 ? { ...this.query } : {}

        if (payload.role && payload.role.length > 0) {
          payload.role =
            payload.role.length === this.roleCount
              ? []
              : payload.role
                .map((e) => this.roleMap[e])
                .filter((e) => {
                  return e != null
                })
        }

        payload = { ...payload, ...this.pagination }

        const res = await getTimeOfSuccess(payload, true, this.Authorization)
        downLoadFileFromRequest(res)
      } catch (error) {
        console.log(error)
      }
    },
    async loadPanelResultByLocation(download = false) {
      try {
        let payload =
          Object.keys(this.query).length > 0 ? { ...this.query } : {}

        if (payload.role && payload.role.length > 0) {
          payload.role =
            payload.role.length === this.roleCount
              ? []
              : payload.role
                .map((e) => this.roleMap[e])
                .filter((e) => {
                  return e != null
                })
        }
        let res
        if (download) {
          res = await getPanelResultByLocation(
            payload,
            true,
            this.Authorization
          )
          downLoadFileFromRequest(res)
        } else {
          res = await getPanelResultByLocation(payload)
          this.panelResultByLocationData = configBarData(res.data)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async loadPanelResultByAgency(download = false) {
      try {
        let payload =
          this.query && Object.keys(this.query).length > 0 ? { ...this.query } : {}

        if (payload.role && payload.role.length > 0) {
          payload.role =
            payload.role.length === this.roleCount
              ? []
              : payload.role
                .map((e) => this.roleMap[e])
                .filter((e) => {
                  return e != null
                })
        }
        let res
        if (download) {
          res = await getPanelResultByAgency(
            payload,
            true,
            this.Authorization
          )
          downLoadFileFromRequest(res)
        } else {
          res = await getPanelResultByAgency(payload)
          if (res.data) {
            this.panelResultByAgencyData = configBarData(res.data)
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleReset() {
      this.selectLevel = { ...this.selectedLevelBak }

      this.selectedQueries = [...this.selectedQueriesBak]
      const { cycle_id } = this.query
      const category = this.selectedQueries
        .filter((e) => e.type == 'category')
        .map((e) => e.label)
      const location = this.selectedQueries
        .filter((e) => e.type == 'location')
        .map((e) => e.label)
      const role = this.selectedQueries
        .filter((e) => e.type == 'role')
        .map((e) => e.label)
      const level = Object.values(this.selectLevel).reduce(
        (prev, next) => prev.concat(next),
        []
      )
      if (cycle_id) {
        this.query = { cycle_id, category, location, role, level }
      } else {
        this.query = { category, location, role, level }
      }
      this.loadData()
    },
    handleClose(q) {
      this.selectedQueries = this.selectedQueries.filter(
        (el) => el.label !== q.label
      )

      this.query = {
        ...this.query,
        [q.type]: this.query[q.type].filter((el) => el != q.label),
      }
      this.loadData()
    },
    handleCategoryFocus() {
      this.categoryOpen = true
      this.selectedQueries = [...this.selectedQueries]
    },
    handleCategoryBlur() {
      this.categoryOpen = false
    },
    handleCategoryCancel() {
      this.$refs['selectCategory'].blur()
    },
    handleLocationFocus() {
      this.locationOpen = true
      this.selectedQueries = [...this.selectedQueries]
    },
    handleLocationCancel() {
      this.$refs['selectLocation'].blur()
    },
    handleRoleFocus() {
      this.roleOpen = true
      this.selectedQueries = [...this.selectedQueries]
    },
    handleRoleCancel() {
      this.$refs['selectRole'].blur()
    },
    handleLevelFocus() {
      this.levelOpen = true
      this.selectedQueries = [...this.selectedQueries]
    },
    handleLevelCancel() {
      this.$refs['selectLevel'].blur()
    },
    async onClickDownloadPanelResultByAgency() {
      let payload =
        Object.keys(this.query).length > 0 ? { ...this.query } : {}

      if (payload.role && payload.role.length > 0) {
        payload.role =
          payload.role.length === this.roleCount
            ? []
            : payload.role
              .map((e) => this.roleMap[e])
              .filter((e) => {
                return e != null
              })
      }
      try {
        const res = await getPanelResultByAgency(
          payload,
          true,
          this.Authorization
        )
        downLoadFileFromRequest(res)
      } catch (error) {
        console.log(error)
      }
    },
  },
  async mounted() {
    await this.loadSelect()
    await this.loadData()
  },
}
</script>
<style lang="less" scoped>
@import url('@/styles/params.less');

.pr-admin-window {
  margin: 16px;
  display: flex;
  flex-direction: columns;
  gap: 24px;
  min-width: 1000px;
}

.download-icon {
  cursor: pointer;
  display: block;
}

.section-first {
  padding: 16px;
  background-color: white;

  .section-row {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:first-child {
      margin-bottom: 16px;
    }

    .title {
      font-weight: bold;
      width: 60px;
      font-size: 12px;
      line-height: 20px;
    }

    .form {
      display: flex;
      flex: 1;
      justify-content: space-between;
      align-items: center;

      .form-item:nth-child(2) {
        flex: 1;
      }
    }

    .label {
      font-weight: 400;
      font-size: 12px;
      width: 60px;
    }

    &.selected {
      .content {
        display: flex;
        flex: 1;
        flex-wrap: wrap;
        gap: 12px;

        &::-webkit-scrollbar {
          display: none;
        }
      }

      .selected-window {
        padding: 2px 4px 2px 8px;
        border-radius: 2px;
        background-color: #eae7de;
        font-weight: 400;
        font-size: 12px;
        display: flex;
        align-items: center;
        flex-shrink: 0;

        img {
          width: 10px;
          height: 10px;
          margin-left: 4px;
          cursor: pointer;
        }
      }

      .reset {
        display: flex;
        align-items: center;
        cursor: pointer;

        img {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }
      }
    }
  }

  .form-item {
    &-select {
      width: 360px;

      /deep/ .ant-select-selector {
        height: 40px;
        padding: 0;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
        padding-left: 10px;
        border: none;

        .ant-select-selection-search {
          height: 40px;
        }

        input {
          height: 100%;
        }
      }

      .placeholder {
        display: flex;
        align-items: center;
        height: 40px;

        img {
          margin-right: 10px;
        }
      }
    }
  }
}

.section-second {
  display: flex;
  gap: 24px;

  &-left {
    flex: 3;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .section-row {
      display: flex;
      gap: 24px;

      &-sub {
        flex: 1;
        background-color: white;
        display: flex;
        align-items: flex-start;

        .section-column {
          padding: 0;
        }

        padding: 16px;
      }

      &-nogap {
        align-items: flex-start;
        background-color: white;
        gap: 0;
        padding: 16px;

        .section-column {
          padding: 0;

          &-header {
            font-weight: 500;
            font-size: 16px;
            line-height: 24px;
            margin-bottom: 25px;
          }

          &-content {
            display: flex;
            align-items: center;

            &-left {
              font-weight: 500;
              margin-right: 24px;

              .ratio {
                font-size: 24px;
                line-height: 32px;
                color: rgba(0, 0, 0, 0.85);
              }

              .amount {
                font-size: 14px;
                line-height: 17px;
                color: #8b8d97;
              }
            }
          }

          .success {
            margin-top: 38px;
            font-size: 30px;
            font-weight: 500;
            line-height: 40px;
          }
        }
      }
    }

    .section-column {
      flex: 1;
      background-color: white;
      padding: 16px;

      &-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title {
          font-weight: 500;
          font-size: 14px;
          line-height: 22px;
        }

        .icon {
          font-size: 14px;
        }
      }

      .members {
        font-weight: 500;
        font-size: 30px;
        line-height: 40px;
        margin-top: 36px;
        margin-bottom: 12px;
      }

      .registers {
        display: flex;

        .register {
          display: flex;
          flex-direction: column;

          &:first-child {
            margin-right: 57px;
          }

          .ratio {
            font-weight: 500;
            font-size: 30px;
            line-height: 40px;
            margin-bottom: 12px;
          }

          .tag {
            font-weight: 500;
            font-size: 14px;
            color: #a5804a;
            line-height: 17px;
            padding: 2px 4px;
            text-align: center;

            background-color: #eae7de;
            border-radius: 4px;
            margin-bottom: 2px;
          }

          .amount {
            color: #8b8d97;
            font-weight: 500;
            line-height: 17px;
            font-size: 14px;
          }
        }
      }

      .applications {
        .ratio {
          font-weight: 500;
          font-size: 30px;
          line-height: 40px;
          margin-bottom: 12px;
        }

        .amount {
          color: #8b8d97;
          font-weight: 500;
          line-height: 17px;
          font-size: 14px;
        }

        .line {
          height: 8px;
          background-color: #eae7de;

          &-applied {
            background-color: #a5804a;
            height: 8px;
          }
        }
      }
    }
  }

  &-right {
    background-color: white;
    flex: 1;
    padding: 16px;

    .section-row-header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .section-title {
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
      }
    }

    .section-row-content {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &:nth-child(2) {
        margin-top: 22px;
      }

      &:nth-child(3) {
        margin-top: 84px;
      }

      &:nth-child(4) {
        margin-top: 84px;
        margin-bottom: 17px;
      }

      .section-label {
        color: #8b8d97;
        flex: 1;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
      }

      .section-number {
        display: flex;
        flex-direction: column;
        margin-right: 21px;
        align-items: center;

        .section-ratio {
          color: #333;
          line-height: 34px;
          font-weight: 500;
          font-size: 24px;
        }

        .section-amount {
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          color: rgba(0, 0, 0, 0.45);
        }
      }

      .download {
        font-size: 20px;
        color: #a5804a;
        margin-left: 21px;
      }
    }
  }
}

.section-third {
  background-color: white;
  padding: 16px;

  .apply-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .apply-category {
    display: flex;
    margin: 30px 0;
    margin-left: 117px;

    &-color {
      width: 10px;
      height: 10px;
      margin-right: 3px;
    }

    &-num {
      font-weight: 400;
      font-size: 24px;
      line-height: 30px;
    }

    &-name {
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
    }

    &>div>div:last-child {
      margin-top: 6px;
      display: flex;
      align-items: center;
    }

    &>div:not(:last-child) {
      margin-right: 40px;
    }
  }

  .apply-table {
    /deep/ .ant-table-thead .ant-table-cell {
      background-color: #d9bd8c33;
    }

    /deep/ .ant-table-thead th.ant-table-cell {
      &::before {
        display: none;
      }

      border: 0.5px solid #eae7de;
    }

    /deep/ .ant-table-thead th.ant-table-cell {
      border-top-width: 1px;
    }

    /deep/ .ant-table-thead th.ant-table-cell:last-child {
      border-right-width: 1px;
    }

    /deep/ .ant-table-thead th:first-child {
      background-color: white;
      border-left-color: white;
      border-top-color: white;
      border-left-width: 1px;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      color: transparent;
    }

    /deep/ tr td.ant-table-cell:first-child {
      border-left-width: 1px;
    }

    /deep/ tr td.ant-table-cell:last-child {
      border-right-width: 1px;
    }

    /deep/ tbody tr:last-child .ant-table-cell {
      border-bottom-width: 1px;
    }

    /deep/ .ant-table-tbody td.ant-table-cell {
      border: 0.5px solid #eae7de;
    }

    max-width: 100%;
    overflow-x: scroll;
  }
}

.section-forth {
  display: flex;
  gap: 24px;

  .section-column {
    background-color: white;
    padding: 16px;
    flex: 1;
  }

  .panel-result-header {
    display: flex;
    justify-content: space-between;

    &-left {
      display: flex;
      align-items: center;

      .title {
        margin-right: 16px;
      }
    }
  }

  .panel-result-content {
    display: flex;
    margin-top: 70px;

    &-left {
      margin: 15px 45px 0 19px;
    }

    &-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 20px;
      margin-right: 39px;
    }
  }

  .time-of-success-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.section-fifth {
  display: flex;
  flex-direction: column;
  gap: 24px;

  &>div {
    flex: 1;
    background-color: white;
    padding: 16px;

    .panel-result-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 40px;
    }
  }
}</style>
